module.exports = __webpack_public_path__ + "static/cadastro_2-509216ab6df8c53ffce20c872fca7308.png";